import React from "react";
import {
	IConsumptionFuelData,
	IVDMDashboardContent,
} from "redux/app/vdmdashboard/@types";

const StatusBadge = ({
	text,
	color = "red",
}: {
	text: string;
	color?: string;
}) => {
	const colorClasses = {
		red: {
			bg: "bg-red-100",
			text: "text-red-700",
			dot: "bg-red-500",
		},
	};

	const classes = colorClasses.red;

	return (
		<span
			className={`inline-flex items-center ml-2 ${classes.bg} ${classes.text} text-xs font-medium px-2 py-0.5 rounded-full`}
		>
			<span className={`w-1.5 h-1.5 ${classes.dot} rounded-full mr-1.5`}></span>
			{text}
		</span>
	);
};

interface IFuelConsumptionTableProps {
	consumptionByFuelType?: IVDMDashboardContent["bunkerConsumptions"]["byFuelType"];
	fuelData?: IConsumptionFuelData;
}

const FuelConsumptionTable = ({
	fuelData,
	consumptionByFuelType = [],
}: IFuelConsumptionTableProps) => {
	const expectedColumns = [
		{ title: "Fuel type", key: "fuelType" },
		{ title: "Daily Consumption", key: "consumption", unit: "mt" },
		{ title: "Daily Consumption limit", key: "consumptionLimit" },
		{ title: "Total Consumption", key: "totalConsumption", unit: "mt" },
		{ title: "ROB", key: "rob" },
	];

	const rows = (consumptionByFuelType || []).map((fuelInfo) => {
		const {
			consumptionByEquipment,
			label,
			sourceByEquipment,
			totalConsumption,
			value,
		} = fuelInfo;
		return {
			fuelType: label,
			totalConsumption,
			rob: "Not available",
			consumptionLimit: "Not available",
			consumption: totalConsumption, // TODO: need to consumption, consumptionLimit & rob values
		};
	});

	if (!rows || rows.length === 0) {
		return (
			<div className="overflow-x-auto mt-3">
				<div className="text-center py-8 text-gray-500 text-sm">
					No fuel consumption data available.
				</div>
			</div>
		);
	}

	return (
		<div className="overflow-x-auto mt-3">
			<table className="min-w-full w-full text-sm text-left text-gray-700 border rounded overflow-x-hidden">
				<thead className="text-xs text-gray-500  bg-gray-50 border-b border-gray-200">
					<tr>
						{expectedColumns.map((column) => {
							return (
								<th
									key={column?.title}
									scope="col"
									className="px-4 py-3 font-medium whitespace-nowrap"
								>
									<span className="uppercase">{column.title}</span>
									{column?.unit ? (
										<span className="ml-0.5">({column?.unit})</span>
									) : null}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{rows.map((row, index) => {
						return (
							<tr
								key={index}
								className="bg-white border-b border-gray-200 last:border-b-0 hover:bg-gray-50"
							>
								{expectedColumns.map((column) => {
									const cell = (row as any)[column.key];
									console.log({ cell });
									const isCellTypeObj =
										typeof cell === "object" && cell !== null;
									return isCellTypeObj ? (
										<>
											<td className="px-4 py-3 whitespace-nowrap text-[12px] md:text-sm">
												{(cell as any)?.value}
												{(cell as any).status?.type && (
													<span className="ml-0.5">
														<StatusBadge
															text={(cell as any)?.status?.message}
														/>
													</span>
												)}
											</td>
										</>
									) : (
										<td className="px-4 py-3 whitespace-nowrap text-[12px] md:text-sm">
											{cell}
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default FuelConsumptionTable;
